// extracted by mini-css-extract-plugin
module.exports = {"region":"PatternLanguageSEO_region__l7Or3","stack":"PatternLanguageSEO_stack__wzeDu","header":"PatternLanguageSEO_header__KtWiJ","link":"PatternLanguageSEO_link__HYVV7"};